import "../../style/globals/PageHeaderTitle.css";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import WrapperStyle from "../../utils/WrapperStyle";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Button } from "@mui/material";
import PageHowToWork from "../../utils/PageHowToWork";
import { useState } from "react";

const ProfileSettingsTitle = () => {
  const [open, setOpen] = useState(false);
  const handleOpenVideo = () => {
    setOpen(true);
  };

  return (
    <>
      <PageHowToWork
        open={open}
        setOpen={setOpen}
        iframe={
          <iframe
            style={{ width: "100%", height: "100%", borderRadius: "7px" }}
            src="https://www.youtube.com/embed/E4pwQo7gBG0"
            title="Bu Sayfa Nasıl Kullanılır l Profil Sayfası"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        }
      />
      <div className="page-header-title" style={WrapperStyle()}>
        <div className="page-header-title-wrapper">
          <div className="page-header-title-headline">
            <SettingsOutlinedIcon
              sx={{
                width: "24px!important",
                height: "24px!important",
              }}
            />
            <h1>Profil Ayarları</h1>
          </div>
          <Button
            sx={{ textTransform: "none" }}
            onClick={handleOpenVideo}
            className="page-header-title-how-link"
          >
            <HelpOutlineOutlinedIcon />
            <span>Bu Sayfa Nasıl Kullanılır?</span>
          </Button>
        </div>
      </div>
    </>
  );
};

export default ProfileSettingsTitle;
